<template>
  <div class="page-box">
    <img class="top-bg" src="@/assets/auth/top-bg.png" alt="" />
    <div class="top-box">
      <div class="title">商户活体认证</div>
      <div class="desc">请核对信息，由本人完成认证</div>
    </div>
    <div class="card-box">
      <div class="row-box">
        <div class="label">姓名</div>
        <div class="label">{{ legalName || "-" }}</div>
      </div>
      <div class="row-box">
        <div class="label">证件号码</div>
        <div class="label">{{ legalCerno || "-" }}</div>
      </div>
      <div class="row-box">
        <div class="label">手机号</div>
        <div class="label">{{ linkPhone || "-" }}</div>
      </div>
    </div>
    <div class="btn" @click="submitEvent">确认信息并开始认证</div>

    <van-dialog
      v-model="show"
      title="提示"
      show-cancel-button
      :confirmButtonText="confirmButtonText"
      :confirmButtonColor="time <= 0 ? '#FF4741' : '#666666'"
      :beforeClose="beforeClose"
      class="confirm-dialog"
    >
      <div class="dialog-content">
        1、用户信息保护提示：基于《个人信息保护法》、《反洗钱法》、《非银行支付机构网络支付业务管理办法》等法律法规要求，落实反洗钱及个人身份识别义务，须对您填写录入/上传的个人身份信息（包括姓名、证件号、证件有效期）、地址信息、人脸信息、银行卡信息进行收集和真实性核验，相关信息将与身份验证的服务机构进行交叉验证，现需询问您是否允许“联动优势”获取前述您的信息，以完成当前操作。联动优势会严格按照法律法规和相关监管部门的规定执行。<br />
        2、警方提示：出售出租、出借、转让本人账户实施违法犯罪活动，将移送司法机关追究相应法律责任；请勿将POS机具用于套现、洗钱等非法业务。
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { getRegisterDetail } from "@/api/common";
export default {
  data() {
    return {
      id: this.$route.query.id,
      legalName: "",
      legalCerno: "",
      linkPhone: "",
      confirmButtonText: "同意",
      time: 5,
      show: false,
      timer: null,
    };
  },

  mounted() {
    this.getRegisterDetailEvent();
  },

  methods: {
    getRegisterDetailEvent() {
      this.$toast({
        message: "加载中...",
        forbidClick: true,
        duration: 10000,
      });
      getRegisterDetail({ id: this.id }).then((res) => {
        this.$toast.clear();
        this.legalName = res.legalName;
        this.legalCerno = res.legalCerno;
        this.linkPhone = res.linkPhone;
      });
    },

    // 创建5秒倒计时
    countdown() {
      this.time = 5;
      this.confirmButtonText = `同意(${this.time}s)`;
      this.timer = setInterval(() => {
        this.time--;
        this.confirmButtonText = `同意(${this.time}s)`;
        if (this.time <= 0) {
          clearInterval(this.timer);
          this.confirmButtonText = "同意";
          this.timer = null;
        }
      }, 1000);
    },

    submitEvent() {
      this.show = true;
      this.countdown();
    },
    beforeClose(action, done) {
      if (action === "confirm") {
        if (this.time <= 0) {
          done();
          this.$router.push({
            path: "/auth/media",
            query: {
              id: this.id,
            },
          });
        } else {
          done(false);
        }
      } else {
        done();
      }
    },
  },
};
</script>
<style lang="less">
#app {
  background-color: #f5f5f5 !important;
}
.confirm-dialog {
  .van-dialog__content {
    padding: 15px 30px;
    .dialog-content {
      text-align: left;
      font-size: 28px;
      color: #333333;
    }
  }
}
</style>
<style lang="less" scoped>
.page-box {
  background-color: #f5f5f5;
  position: relative;
  padding-top: 40px;
  .top-bg {
    position: absolute;
    top: -175px;
    left: 0;
    right: 0;
    z-index: 0;
    width: 100%;
  }
  .top-box {
    position: relative;
    z-index: 1;
    .title {
      font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
      font-weight: 700;
      font-size: 56px;
      color: #3d3d3d;
      text-align: center;
      margin-bottom: 12px;
    }
    .desc {
      font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
      font-size: 28px;
      color: #8b7f7f;
      text-align: center;
    }
  }
  .card-box {
    position: relative;
    z-index: 1;
    width: 686px;
    margin: 520px auto 0;
    background: linear-gradient(180deg, #fff5f4 0%, #ffffff 100%);
    border-radius: 32px;
    border: 2px solid #ffffff;
    padding: 32px;
    box-sizing: border-box;
    .row-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 32px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .btn {
    margin: 166px auto 0;
    width: 654px;
    height: 98px;
    background: #ff4741;
    font-size: 34px;
    color: #ffffff;
    text-align: center;
    line-height: 98px;
    border-radius: 14px;
  }
}
</style>
